import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  belongsTo,
  date,
  hasMany,
  references,
} from '@apexdesigner/schema-tools';

export const session = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    date: date().nullable().optional().presentAs('date').describe('Date'),

    comments: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Comments'),

    sessionLengthMinutes: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Session Length (minutes) - Label matches Apricot; required before the log can be complete (opp 8106)',
      ),

    complete: z.boolean().nullable().optional().describe('Complete'),

    sessionNumber: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Session Number - The sequence number of this session for the student within the curriculum',
      ),

    attendanceId: z.number().hidden().describe('Foreign key to Attendance'),

    curriculumId: z
      .number()
      .presentAs('reference')
      .describe('Foreign key to Curriculum'),

    attendance: belongsTo('Attendance'),

    curriculum: references('Curriculum'),

    sessionActivityItems: hasMany('SessionActivityItem'),
  })
  .describe('A tutoring session that took place for an attendance record.')
  .as('Session');

export { session as sessionSchema };
